import type { ThemeConfig } from "antd";

/** Brand colors aligned with mobile + admin design mock. */
export const tamsThemeColors = {
	primary: "#2A9D8F",
	primaryForeground: "#FFFFFF",
	accent: "#E9C46A",
	background: "#F5F5F5",
	siderBg: "#F7F7F7",
	surface: "#FFFFFF",
	foreground: "#1A2B27",
	muted: "#8A9A96",
	border: "#E5E7EB",
	borderSubtle: "#F0F0F0",
	success: "#57CC99",
	warning: "#F4A261",
	error: "#E76F51",
	primarySoft: "rgba(42, 157, 143, 0.12)",
} as const;

export const ADMIN_SIDER_WIDTH = 220;
export const ADMIN_SIDER_COLLAPSED_WIDTH = 80;

export const tamsAntdTheme: ThemeConfig = {
	token: {
		colorPrimary: tamsThemeColors.primary,
		colorSuccess: tamsThemeColors.success,
		colorWarning: tamsThemeColors.warning,
		colorError: tamsThemeColors.error,
		colorInfo: tamsThemeColors.primary,
		colorBgLayout: tamsThemeColors.background,
		colorBgContainer: tamsThemeColors.surface,
		colorBgElevated: tamsThemeColors.surface,
		colorText: tamsThemeColors.foreground,
		colorTextSecondary: tamsThemeColors.muted,
		colorBorder: tamsThemeColors.border,
		colorBorderSecondary: tamsThemeColors.borderSubtle,
		borderRadius: 10,
		fontFamily:
			'"Hiragino Sans", "Noto Sans JP", system-ui, -apple-system, sans-serif',
		controlHeight: 36,
	},
	components: {
		Layout: {
			headerBg: "transparent",
			headerHeight: 64,
			siderBg: tamsThemeColors.siderBg,
			bodyBg: tamsThemeColors.background,
		},
		Menu: {
			itemBg: "transparent",
			subMenuItemBg: "transparent",
			itemSelectedBg: tamsThemeColors.primary,
			itemSelectedColor: tamsThemeColors.primaryForeground,
			itemHoverBg: "rgba(0, 0, 0, 0.04)",
			itemActiveBg: tamsThemeColors.primary,
			itemColor: tamsThemeColors.foreground,
			itemHeight: 44,
			itemMarginInline: 12,
			itemPaddingInline: 16,
			itemBorderRadius: 22,
			iconSize: 16,
			collapsedWidth: ADMIN_SIDER_COLLAPSED_WIDTH,
			activeBarBorderWidth: 0,
		},
		Table: {
			headerBg: "#FAFAFA",
			headerColor: "rgba(0, 0, 0, 0.45)",
			borderColor: tamsThemeColors.borderSubtle,
			rowHoverBg: "rgba(0, 0, 0, 0.02)",
			headerSplitColor: tamsThemeColors.borderSubtle,
		},
		Card: {
			borderRadiusLG: 12,
		},
		Button: {
			primaryShadow: "none",
			borderRadius: 10,
			controlHeight: 36,
		},
		Input: {
			borderRadius: 10,
		},
		Select: {
			borderRadius: 10,
		},
		DatePicker: {
			borderRadius: 10,
		},
		Tag: {
			borderRadiusSM: 8,
		},
	},
};
